import ScheduledSucessfullyContainer from './ScheduledSucessfullyContainer';

export default ScheduledSucessfullyContainer;
